import { AlertTriangle, X } from "lucide-react";
import { useState } from "react";

export default function TestBanner() {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div 
      className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-black px-4 py-2 text-center text-sm font-medium"
      data-testid="test-banner"
    >
      <div className="flex items-center justify-center gap-2">
        <AlertTriangle className="w-4 h-4 flex-shrink-0" />
        <span>
          <strong>Testing Environment</strong> — This site is currently under development and testing. 
          Data may be reset without notice.
        </span>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="absolute right-4 top-1/2 -translate-y-1/2 hover:bg-amber-600 rounded p-1 transition-colors"
        aria-label="Dismiss banner"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
